import React from 'react';
import { TableGroupModel } from '../../models/index.model';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

function PrintTable({ colHeadings, tableRows, isShowIconOnCell }) {
  const renderCell = (row, index) => {
    if (isShowIconOnCell) {
      const iconData = row.getIconCellData(index);

      if (!iconData) return;
      return (
        <img
          src={iconData?.fields?.iconUrl?.value}
          alt={iconData?.fields?.iconAlt?.value}
          className="model-detail-specification-table__spec--cell-icon-img"
        />
      );
    }
    return row.getCellData(index).value;
  };

  return (
    <div className="model-detail-specification-table-print-wrapper">
      <div className="model-detail-specification-table-print model-detail-specification-table-print__grid">
        <div className="model-detail-specification-table-print__col-heading"></div>
        {colHeadings?.map((val) => (
          <div className="model-detail-specification-table-print__col-heading">{val?.text?.value}</div>
        ))}
        {tableRows.map((obj) =>
          obj instanceof TableGroupModel ? (
            <>
              <div className="model-detail-specification-table-print__spec-category-row">
                <div className="model-detail-specification-table-print__left-most-cell model-detail-specification-table-print__spec-category-row__inner-box-wrapper">
                  <div className="model-detail-specification-table-print__spec-category-row__inner-box">
                    <RichText field={obj?.title} />
                  </div>
                </div>
                <div className="model-detail-specification-table-print__spec-category-row__empty-row"></div>
              </div>
              {obj.items &&
                obj.items.map((subObj, accIndex, subArr) => (
                  <>
                    {subObj.title.value && (
                      <div
                        className={`
                                model-detail-specification-table-print__left-side-accordion-spec-title
                                model-detail-specification-table-print__left-most-cell
                                model-detail-specification-table-print__spec-row-child
                              `}
                      >
                        <div
                          className={`model-detail-specification-table-print__left-side-accordion-spec-title__inner-box 
                          ${
                            subArr.length === accIndex + 1
                              ? 'model-detail-specification-table-print__left-side-accordion-spec-title__inner-box--last-row'
                              : ''
                          }
                        `}
                        >
                          <div>
                            <RichText field={subObj.title} />
                          </div>
                        </div>
                      </div>
                    )}
                    {colHeadings.map((spec, specIndex) => (
                      <div
                        key={`model-detail-specification-table-print__spec${Math.random()}`}
                        className={`
                        model-detail-specification-table-print__spec
                        model-detail-specification-table-print__spec--${specIndex % 2 === 0 ? 'even' : 'odd'}
                        model-detail-specification-table-print__spec-row-child
                        ${subArr.length === accIndex + 1 ? 'model-detail-specification-table-print__spec--last-row' : ''}
                      `}
                      >
                        {renderCell(subObj, specIndex + 1)}
                      </div>
                    ))}
                  </>
                ))}
            </>
          ) : (
            <>
              {obj?.title?.value && (
                <div
                  className={`
              model-detail-specification-table-print__left-side-accordion-spec-title
              model-detail-specification-table-print__left-most-cell
              model-detail-specification-table-print__spec-row-child
            `}
                >
                  <div className="model-detail-specification-table-print__left-side-accordion-spec-title__inner-box model-detail-specification-table-print__left-side-accordion-spec-title__inner-box--last-row">
                    <div>
                      <RichText field={obj?.title} />
                    </div>
                  </div>
                </div>
              )}
              {colHeadings.map((spec, specIndex) => (
                <div
                  key={`model-detail-specification-table-print__spec-${spec}`}
                  className={`
                    model-detail-specification-table-print__spec
                    model-detail-specification-table-print__spec--${specIndex % 2 === 0 ? 'even' : 'odd'}
                    model-detail-specification-table-print__spec--last-row
                  `}
                >
                  {renderCell(obj, specIndex + 1)}
                </div>
              ))}
            </>
          )
        )}
      </div>
    </div>
  );
}

export default PrintTable;
